import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidCategoriseYesNo } from '../../../../../mechanics/rid-categorise-yes-no/rid-categorise-yes-no';

@Component({
  selector: 'app-yes-no-word-page',
  imports: [RidCategoriseYesNo],
  templateUrl: './yes-no-word-page.html',
})
export class YesNoWordPage {
  protected readonly $router = inject(Router);
}
